/**
 * 取消规则
 */
import React from 'react';
import styles from './index.module.scss';
import { XOKButton, showConfirm, XInputNum, XTitle } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message, Tooltip, Radio, InputNumber } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import model from '@/reducers/system/operatingrule/model';
import RuleModal from './modal/RuleModal';
import { InfoCircleOutlined } from '@ant-design/icons';


class Canceltime extends React.PureComponent {

    state = {
        currentOpenMode: '', // 当前需要打开的弹窗
        openModeParam: {}, // 当前需要打开的弹窗的入参
        cancletask: null,//骑士接单后未取件取消任务
        isExempt: 0,//是否免责
    }

    componentDidMount() {
        this.props.getTimeoutDetail();//超时规则数据acton
    }

    componentDidUpdate(prevProps) {
        if (this.props.timeoutDetail !== prevProps.timeoutDetail) {
            let { params = {} } = this.props.timeoutDetail;
            this.setState({
                cancletask: params.CANCELABLE_TIME,
                isExempt: params.ENABLE_DISCLAIMER
            });
        }
    }


    // 新建规则
    _createRule = () => {
        this.setState({
            currentOpenMode: 'creat'
        });
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize } = this.state;
        this.searchCache = {
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getCancelRuleList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 表格操作
    _tableAction = (item, tabletype, value) => {
        switch (tabletype) {
            case 'editor':
                this.setState({
                    currentOpenMode: 'editor',
                    openModeParam: value,
                });
                break;
            case 'delete':
                showConfirm('确定要删除此信息吗？', '你还要继续吗？', () => {
                    http('/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderCancelRuleMisService.deleteRules', { id: item }, 'POST').then(() => {
                        message.success('删除成功');
                        this.props.getCancelRuleList(this.searchCache);
                    }).catch((res = {}) => {
                        message.error(res.message);
                    });
                }, () => { });
                break;
            case 'switch'://状态
                http('/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderCancelRuleMisService.updateStatus', {
                    id: item.id,
                    status: (value === false) ? 0 : 1,
                }, 'POST').then(() => {
                    message.success('修改成功');
                    this.props.getCancelRuleList(this.searchCache);
                }).catch((reject = {}) => {
                    message.error(reject.message);
                });
                break;
        }
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.searchCache = { ...this.searchCache, pageSize, pageNum };
        this.props.getCancelRuleList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageSize, pageNum }); // 【第5步：缓存分页状态】
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case 'creat':
                return <RuleModal title='创建反馈类型' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            case 'editor':
                return <RuleModal title='编辑反馈类型' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '', openModeParam: {} });
        if (status) {
            this.props.getCancelRuleList(this.searchCache);// 列表查询方法
        }
    }

    //保存
    _savehandle = (code, value) => {
        let params = {
            [code]: value
        };
        http('/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderRulesParamService.updateParams', { params }, 'POST').then(() => {
            message.success('保存成功');
        }).catch((e = {}) => {
            message.error(e.message);
        });
    }

    //提示
    renderTips = () => {
        return <div className={styles.pois}>
            <Tooltip title="光标移开触发保存">
                <InfoCircleOutlined />
            </Tooltip>
        </div>;
    }

    //请求
    _request = (data) => {
        http('/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderRulesParamService.updateParams', { params: data }, 'POST')
            .then(() => {
                message.success('更新取消规则参数操作成功');
                this.props.getTimeoutDetail();
            }).catch((err = {}) => {
                message.error(err.message);
            });
    }

    render() {
        const { tableList, timeoutDetail: { params = {} } = {} } = this.props;
        const { cancletask, isExempt } = this.state;
        return (
            <KeepAlive id='2' render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    {/* <XTitle style={{ marginBotton: 5 }} label='骑士接单后未取件取消任务' />
                    <div className={styles.timeoutContent}>
                        <div className={styles.item}>
                            <label>骑士接单后未取件，在</label>
                            <div className={styles.renderTips}>
                                <XInputNum
                                    inputStyle={{ width: '100px', }}
                                    placeholder='请输入'
                                    precision={0}
                                    min={1}
                                    max={60}
                                    value={cancletask}
                                    bindThis={this}
                                    bindName='cancletask'
                                    onBlur={(e) => {
                                        this._savehandle('CANCELABLE_TIME', e.target.value);
                                    }}
                                />
                                {this.renderTips()}
                            </div>
                            <span>分钟内骑士可以取消任务，取消后配送订单回到任务大厅，不产生处罚。</span>
                        </div>
                    </div> */}
                    <XTitle style={{ margin: '5px 0' }} label='用户取消规则' />
                    <div className={styles.mComponent}>
                        <div className={styles.label}>开启用户免责：</div>
                        <div className={styles.content}>
                            <Radio.Group
                                value={isExempt}
                                onChange={e => this._request({ ENABLE_DISCLAIMER: e.target.value })}>
                                <Radio key={0} value={0}>不开启</Radio>
                                <Radio key={1} value={1}>开启</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                    {
                        isExempt == 1 &&
                        <div className={styles.mComponent}>
                            <div className={styles.label}>免责条款：</div>
                            <div className={styles.content}>
                                用户从第1次到第
                                <InputNumber
                                    defaultValue={params.RELIEF_CLAUSE_LAW_TIMES}
                                    onBlur={e => this._request({ RELIEF_CLAUSE_LAW_TIMES: e.target.value })}
                                    style={{ margin: '0 10px' }}
                                    precision={0} max={10} min={1}
                                />
                                次取消订单不需要支付取消费用。（范围1~10）
                            </div>
                        </div>
                    }
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: '90px', marginLeft: '30px' }} label='新建规则' onClick={this._createRule} />
                    </div>
                    <TableContent renderData={tableList} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                    {this._renderMode()}
                </div>
            </KeepAlive>
        );
    }
}

Canceltime.propTypes = {
    history: PropTypes.object, // 路由history对象
    updateContent: PropTypes.func, // 路由跳转

    timeoutDetail: PropTypes.object,
    getTimeoutDetail: PropTypes.func,//超时规则数据(action)
    tableList: PropTypes.object,
    getCancelRuleList: PropTypes.func,//表格数据(action)
};

const mapStateToProps = (state) => {
    return {
        timeoutDetail: state.operatingrule.timeoutDetail,
        tableList: state.operatingrule.cancelList,
    };
};
export default connect(mapStateToProps, model.actions)(Canceltime);
